import { render, staticRenderFns } from "./category-web-icon.vue?vue&type=template&id=33762891&scoped=true&"
import script from "./category-web-icon.vue?vue&type=script&lang=js&"
export * from "./category-web-icon.vue?vue&type=script&lang=js&"
import style0 from "./category-web-icon.vue?vue&type=style&index=0&id=33762891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33762891",
  null
  
)

export default component.exports